<div class="chart-row">
  <p class="chart-caption">{{Text}}<i *ngIf="ChartType==='SATISFACTION'" class="fa fa-star" ></i></p>
  <div class="bar-wrap">
    <div class="chart-bar"  #barValue>
      <div class="circle-holder">
        <div class="circle-text">
          <div>{{Value}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
